export enum UsersApiTag {
  users = "users",
  user = "user",
  userProfile = "userProfile",
  generalUserProfile = "generalUserProfile",
  userDocuments = "userDocuments",
  userCustomFields = "userCustomFields",
}
